<template>
    <div class="cancelplan-root">
        <div class="root-container" v-if="showContent">
            <div class="content-top">
                <h1>{{ $t('cancel_plan.title', {
                    planname: sub.plan.title
                }) }}</h1>
            </div>
            <steps :stepsData="stepsData" :stepsIndex="highLight" class="step-com"></steps>

            <div class="step-one">
                <div class="middle-content">
                    <p class="package">{{ $t('cancel_plan.plan_details') }}</p>
                    <plan-message :list="message" class="plan-message" v-if="sub.plan"></plan-message>
                </div>
                <p class="package">{{ $t('cancel_plan.are_you_sure') }}</p>
                <div class="middle-before" v-if="sub.plan">
                    <p class="package canc-plan">
                        <span class="benefit"> &bull;</span>
                        <span v-html="$t('cancel_plan.take_effect')"></span>
                    </p>
                    <p class="package canc-plan">
                        <span class="benefit">&bull;</span>
                        <span v-html="$t('cancel_plan.before_cancel')"></span>
                    </p>
                    <section class="benefit-box">
                        <p class="info-grey three-service"><span>&bull;</span> &nbsp; <span v-html="$options.filters.planHistory(sub.plan)"></span>
                        </p>
                        <p class="info-grey three-service"><span>&bull;</span> &nbsp; <span v-html="$options.filters.planCamera(sub.plan)"></span></p>
                        <p v-if="!FEATURE('dashboard.used_space')" class="info-grey three-service"><span>&bull;</span> &nbsp; <span v-html="$options.filters.planCapacity(sub.plan)"></span></p>
                    </section>
                    <p class="package canc-plan" style="margin:0">
                        <span class="benefit">&bull;</span>
                        <span v-html="$t('cancel_plan.two_week_clean')"></span>
                    </p>
                </div>

                <div class="middle-reasons">
                    <p class="package">{{ $t('cancel_plan.cancel_reason') }}</p>
                    <section class="reasons-box">
                        <div class="reasons-left">
                            <div class="choose-checkbox">
                                <reo-radio class="circle" type="circle" size="small" v-model="downloadOne" label="I want to switch my plan.">
                                    <span class="info-grey">{{$t('cancel_plan.reason_first')}}</span>
                                </reo-radio>
                                <div class="reasons-right"  v-if="switchable && !$store.state.user.showBeta">
                                    <router-link class="ui-link" to="/user/update-plan/">
                                        <span class="text">{{ $t('cancel_plan.switch_plan')}}</span><span class="ui-icon icon-icon_arrow-right"></span>
                                    </router-link>
                                </div>
                            </div>
                            <div class="choose-checkbox">
                                <reo-radio class="circle" type="circle" size="small" v-model="downloadOne" label="I prefer the local storage.">
                                    <span class="info-grey">{{$t('cancel_plan.reason_second')}}</span>
                                </reo-radio>
                            </div>
                            <div class="choose-checkbox">
                                <reo-radio class="circle" type="circle" size="small" v-model="downloadOne" label="My Current plan is expensive.">
                                    <span class="info-grey">{{$t('cancel_plan.reason_third')}}</span>
                                </reo-radio>
                            </div>
                            <div class="choose-checkbox">
                                <reo-radio class="circle" type="circle" size="small" v-model="downloadOne" label="Other.">
                                    <span class="info-grey">{{$t('cancel_plan.reason_forth')}}</span>
                                </reo-radio>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="middle-text">
                    <p v-html="$t('cancel_plan.notice')"></p>
                </div>
                <div class="check-ok">
                    <reo-checkbox v-model="sureSend" size="small"></reo-checkbox>
                    <span class="red">*</span>
                    <span>{{ $t('cancel_plan.got_it') }}</span>
                </div>

                <div class="button-box">
                    <router-link to="/user/dashboard/" class="ui-button empty-button">{{ $t('cancel_plan.no_keep') }}</router-link>
                    <button class="ui-button primary-button" @click="continueCancel">{{ $t('cancel_plan.yes_cancel') }}</button>
                </div>
            </div>
        </div>
        <reo-dialog
        v-if="showPaypalDialog"
        class="paypal-dialog"
        title="paypal"
        labelOfConfirm="confirm"
        labelOfCancel="cancel"
        @confirm="continueCancel"
        @cancel="showPaypalDialog = false; payerAccount = '';">
            <div class="paypal-dialog-inner">
                <label for='payerAccount'>payerAccount:<span class='warn-tips'>*</span></label>
                <div>
                    <input id='payerAccount' type="text" v-model.trim="payerAccount" placeholder="please enter your payerAccount" autocomplete="false">
                    <p class='err-tips' v-show='!payerAccount.length && showTips'>{{$t('errors.payer_account_required')}}</p>
                </div>
            </div>
        </reo-dialog>
    </div>
       
</template>

<script>
import reoCheckbox from '@/basic/Checkbox';
import reoRadio from '@/basic/Radio';
import { deleteProduct, orderedProductInfo, previewRefundInfo } from '@/api/plan';
import { unfoldError } from '@/common/js/notice';
import steps from '@/basic/Steps';
import { subscription as subStatus } from '@/config/status';
import planMessage from '@/components/planMessage';
import { checkBeta } from '@/api/cart';
import ReoDialog from '@/basic/Dialog';

export default {

    data () {

        return {

            downloadOne: '',
            sureSend: false,
            address: this.$store.state.user.user.email.address,
            phone: '+' + this.$store.state.user.user.mobilePhone.number,
            sub: {},
            refundArr: [],
            chooseRadioObj: {},
            stepsData: [{
                name: '1',
                value: 1
            },
            {
                name: '2',
                value: 2
            }],
            switchable: false,
            showContent: false,
            payerAccount: '',
            payerFrom: '',
            showPaypalDialog: false,
            showTips: false
        };

    },

    components: {

        reoCheckbox,
        reoRadio,
        steps,
        planMessage,
        ReoDialog
    },

    async created () {

        await checkBeta();
        this._orderedProductInfo();
    
    },

    methods: {

        _previewRefundInfo () {

            previewRefundInfo( this.sub.id ).then( res => {

                this.refundArr = res.refund;
 
            }).catch( err => {

                console.error( err );

            });

        },

        _orderedProductInfo () {

            orderedProductInfo().then( res => {

                this.sub = res;
                if ( res.nextSwitchableAt === 0 || new Date().getTime() > res.nextSwitchableAt ) {

                    this.switchable = true;

                }
                this.showContent = true;
                this._previewRefundInfo();
    
            }).catch( err => {

                console.error( err );
                
            });

        },

        continueCancel () {

            if ( this.showPaypalDialog && !this.payerAccount.trim().length ) {

                this.showTips = true;
                return;

            }

            let sub = this.sub;
            if ( sub.status === subStatus.INACTIVE ) {

                unfoldError( 'errors.plan_not_available' );

            } else if ( sub.status === subStatus.ACTIVATING || sub.status === subStatus.DEACTIVATING ) {

                unfoldError( 'errors.sub_processing' );

            } else if ( !this.sureSend ) {

                unfoldError( 'errors.checkbox_required' );

            } else {

                this.payerFrom = this.payerAccount ? 'paypal' : '';
                this.chooseRadioObj = {

                    reason: this.downloadOne,
                    payerFrom: this.payerFrom ? this.payerFrom : undefined,
                    payerAccount: this.payerAccount ? this.payerAccount : undefined

                };
                this.chooseRadioObj = JSON.parse( JSON.stringify( this.chooseRadioObj ));

                deleteProduct( sub.id, this.chooseRadioObj ).then( res => {
                    
                    this.$router.push({

                        path: '/user/cancel-plan/complete/',
                        query: {
                            plan_name: sub.plan.title
                        }

                    });
            
                }).catch( err => {

                    if ( err.response.data.error.symbol === 'cannot_update_refund' ) {

                        unfoldError( 'errors.cannot_update_refund' );
                        this.showPaypalDialog = false;

                    } else if ( err.response.data.error.symbol === 'payer_account_required' ) {

                        this.showPaypalDialog = true;

                    } else {

                        unfoldError( 'errors.server_error' );
                        this.showPaypalDialog = false;

                    }

                    this.showTips = false;
                    console.error( err );

                });

            }

        }

    },

    computed: {

        highLight () {

            let { path } = this.$route;
            return path === '/user/cancel-plan/complete/' ? 1 : 0;

        },

        message () {

            let sub = this.sub;
            let refundArr = this.refundArr;
            let account;
            if ( this.FEATURE( 'cloud.email_check' )) {

                account = this.phone;
            
            } else {

                account = this.address;
            
            }
            let result = [
                {
                    label: this.$t( 'cancel_plan.account' ),
                    texts: [
                        account
                    ],
                    red: true
                },
                {
                    label: this.$t( 'cancel_plan.current_plan' ),
                    texts: [
                        this.$options.filters.planName( sub.plan )
                    ],
                    red: true
                }
            ];

            if ( refundArr && refundArr.length > 0 ) {

                let refundText = refundArr.map(( item ) => {

                    return `${item.currency} ${item.value}`;

                }).join( ' + ' );
                
                result.push({

                    label: this.$t( 'cancel_plan.refund' ),
                    texts: [
                        refundText
                    ],
                    red: true

                });

            }

            return result;

        }

    }

};
</script>

<style lang="less" scoped>
    .paypal-dialog .paypal-dialog-inner {
        width: 6rem;
        height: 1rem;
        font-size: 0.24rem;
        display: flex;

        label{
            height: 0.46rem;
            line-height: 0.46rem;
            margin-right: 0.2rem;

            .warn-tips{
                color: #f00;
                margin-left: 0.05rem;
            }
        }

        div{
            width: 100%;

            input{
                outline: none;
                -webkit-box-shadow: none;
                box-shadow: none;
                padding: 0;
                border: 1px solid #ccc;
                height: 0.46rem;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 100%;
                font-size: 0.18rem;
                border-radius: 0.05rem;
                padding: 0 0.16rem;
            }

            .err-tips{
                color: #f00;
                font-size: 0.18rem;
                margin-top: 0.1rem;
                text-align: left;
            }
        }
    }
    .cancelplan-root {
        margin: auto;
        max-width: 1200px;
        border:solid 0.01rem #fff;
        border-radius: 0.2rem;
        background-color:#fff;
        .root-container{
           width: 765px;
           margin: auto;
        }
        .content-top {
            text-align: center;
            h1 {
                margin: 0.6rem 0 0.55rem 0;
                font-weight: 700;
                font-size: 0.36rem;
                color: #333;
            }
        }
        
    }
    .middle-content {
        padding: 0.3rem 0 0.5rem 0;
    }
    .package {
        font-weight: 700;
        font-size: 0.2rem;
        margin-bottom: 0.2rem;
    }
 
    .package.canc-plan{
        margin-bottom: 0.1rem;
        font-weight: 400;
        font-size: 0.16rem;
        display: flex;
        .benefit{
            padding-right:0.15rem;;
        }
    }
    .middle-before {
        padding: 0 0 0.3rem 0;
    }
    .benefit-box {
        margin-left:0.2rem;
        padding-bottom: 0.1rem;
        .info-grey {
            color: #666;
            font-size: 0.16rem;
            font-weight: 400;
            line-height: 1.5;
        }
        .three-service+.three-service{
            margin-top: 0.04rem;
        }
    }
    .middle-reasons {
        margin: 0 0 0.2rem 0;
        padding-bottom: 0.44rem;
        border-bottom: solid 0.01rem #dddddd;
    }
    .reasons-box {
       .info-grey {
            color: #666;
            font-size: 0.16rem;
            font-weight: 400;
            padding-bottom: 0.04rem;
            display: inline-block;
        }
    }
    .reasons-right {
        margin-left:0.4rem;
        position: relative;
        top:0.02rem;
        a {
            .text {
                font-weight: 500;
                font-size: 0.16rem;
            }
        }
    }
    .choose-checkbox {
        display: flex;
    }
    .middle-text {
        p {
            color: #333;
            font-size: 0.16rem;
            font-weight: 400;
        a {
            color: @theme;
            cursor: pointer;
        }
      }
    }
    .check-ok {
        margin: 0.15rem 0 0.7rem 0;
        .checkbox-wrap-container{
            margin-right: 0.1rem;
        }
        span {
            font-weight: 500;
            font-size: 0.16rem;
            vertical-align: middle;
        }
    }
    .button-box {
        margin-bottom: 0.7rem;
        text-align: center;
        .ui-button+.ui-button{
            margin-left: 0.4rem;
        }
    }
    @media @mobile{
        .cancelplan-root {
            padding: 0 15px;
            .root-container{
               width:100%;
            }
            .content-top {
                h1 {
                    margin: 1rem 0 0.6rem 0;
                    font-weight: 500;
                    font-size: 0.52rem;
                    color: #333;
                }
            }
            .step-com{
                .steps-item{
                    width:0.44rem;
                    padding: 0 0.44rem;
                }
            }
        }
        .middle-content {
            padding: 0.6rem 0 0.8rem 0;
        }
        .package {
            font-weight: 500;
            font-size: 0.36rem;
            margin-bottom: 0.3rem;
        }
        .package.canc-plan{
            margin-bottom: 0.2rem;
            font-weight: 400;
            font-size: 0.26rem;
            display: flex;
            .benefit{
                padding-right:0.15rem;
            }
        }

        .middle-before {
            padding: 0 0 0.6rem 0;
        }
        .benefit-box {
            margin-left:0.2rem;
            padding-bottom: 0.2rem;
            .info-grey {
                color: #666;
                font-size: 0.26rem;
                font-weight: 400;
            }
            .three-service+.three-service{
                margin-top: 0.15rem;
            }
        }
        .middle-reasons {
            margin: 0 0 0.44rem 0;
            padding-bottom: 0.14rem;
            border-bottom: solid 0.01rem #dddddd;
        }
        .reasons-box {
            .info-grey {
                color: #666;
                font-size: 0.26rem;
                font-weight: 400;
                margin-left: 0.1rem;
                margin-bottom: 0.3rem;
                // line-height: 2;
                display: inline-block;

            }
        }
        .reasons-right {
            margin-left:0;
            position: relative;
            margin-left:0.2rem;
            a {
                .text {
                    font-weight: 500;
                    font-size: 0.26rem;
                }
            }
        }
        .choose-checkbox {
            display: flex;
            flex-wrap: nowrap;
            .circle {
                line-height: 0.4rem;
            }
        }
        .middle-text {
            p {
                color: #333;
                font-size: 0.26rem;
                font-weight: 400;
                a {
                    color: @theme;
                    cursor: pointer;
                    font-weight: 400;
                }
            }
        }
        .check-ok {
            margin: 0.22rem 0 0.6rem 0;
            span.red{
                margin-left:0.1rem;
            }
            span {
                font-weight: 500;
                font-size: 0.26rem;
            }
        }
        .button-box {
            display: flex;
            padding: 0 0 1rem 0;
            margin:0;
            flex-direction: column;
            .ui-button{
                width: 100%;
                padding: 0;
            }
            .ui-button+.ui-button{
                margin: 0.2rem 0 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/cancelPlans/cancelPlan.vue